import styled from 'styled-components'

import Breadcrumb from '../../components/Breadcrumb'
import { mobileBreadcrumbStyles } from '../../components/Breadcrumb/styled'

export const TemplateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  @page {
    margin: 0;
  }
`
export const Main = styled.article``
export const Secondary = styled.aside`
  @media print {
    display: none;
  }
`

export const MobileBreadcrumb = styled(Breadcrumb)`
  ${mobileBreadcrumbStyles}
  @media print {
    display: none;
  }
`
